var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3713_37700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3713_37700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H50V50H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3713_37700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7472 22.2344L3.01758 21.1072L12.4803 11.6444C15.596 8.52871 20.3101 7.94512 24.0245 9.89375",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.793 35.4487L28.9022 46.9922L38.3651 37.5294C41.5937 34.3008 42.1033 29.3559 39.8939 25.5855",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7241 25.4888C39.0184 26.3053 38.2728 27.1078 37.4881 27.8925C33.5412 31.8394 29.1404 34.7984 24.7955 36.6552C23.5233 37.1989 22.1239 36.9286 21.1455 35.9502L14.0419 28.8467C13.0635 27.8683 12.7933 26.4689 13.3371 25.1966C15.1938 20.8517 18.1527 16.4511 22.0996 12.504C30.3804 4.22323 40.6582 0.288657 48.2277 1.76444C49.5637 8.61659 46.466 17.6883 39.7241 25.4888Z",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8047 3.37373L46.2649 13.834",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3203 21.7405L28.3045 33.7246",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6427 15.3494C35.9385 16.6452 35.9385 18.7461 34.6427 20.0418C33.3469 21.3376 31.2461 21.3376 29.9503 20.0418C28.6546 18.7461 28.6546 16.6452 29.9503 15.3494C31.2461 14.0536 33.3469 14.0536 34.6427 15.3494Z",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2779 36.7318L1.46875 48.541",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58623 32.0389L4.59766 36.0273",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9709 41.4236L13.9824 45.4121",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3713_37700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket1);
export default __webpack_public_path__ + "static/media/rocket 1.5dafb0c8ffb0b7993b04c8096eb71c6a.svg";
export { ForwardRef as ReactComponent };